import { PathRouteProps } from "react-router-dom";
import { Routes } from "./routes";
import {
  HowItWorks,
  UseCases,
  Pricing,
  PrivacyPolicy,
  TermsOfUse,
  ContactUs,
  FAQ,
  TalentEnablement,
  TalentEnablementPreview,
  EmailVerification,
  Events,
  ForgotPassword,
  Home,
  NewPassword,
  CreditsBilling,
  Settings,
  Signin,
  Signup,
  PublishAssessment,
  PreAssessment,
  Assessment,
  ManageJobs,
  ReviewTalents,
  ReviewTalentsCVAnalysis,
  AssessmentReport,
  CompareCandidatesPage,
  AssessmentFeedback,
  PublicReportPage,
  Analytics,
} from "pages";
import { AuthLayout, AuthLayout2, EmployerDashboardLayout, LandingLayout } from "layout";

// Route Builder Item Props
export interface RouteBuilderItem extends PathRouteProps {
  Layout?: React.FC<any>; // If you wish to add a layout to the page
  Element: React.FC;
  props?: any;
  isProtected?: boolean;
}

/**
 * ROUTE BUILDER
 *
 * ===============================================
 *
 * This is a list of all our application routes.
 *
 * A single item on this list contains the necessary Route props needed by React Router to do it's job.
 *
 * If you wish to add a new route to the application,
 * just fulfill all the necessary props needed by the RouteBuilder item. Ciao!
 *
 */
export const RouteBuilder: RouteBuilderItem[] = [
  {
    path: Routes.home,
    Element: Home,
    Layout: LandingLayout,
    props: {
      active: "home",
    },
  },
  {
    path: Routes.howItWorks,
    Element: HowItWorks,
    Layout: LandingLayout,
    props: {
      active: "howItWorks",
    },
  },
  {
    path: Routes.useCases,
    Element: UseCases,
    Layout: LandingLayout,
    props: {
      active: "useCases",
    },
  },
  {
    path: Routes.pricing,
    Element: Pricing,
    Layout: LandingLayout,
    props: {
      active: "pricing",
    },
  },
  {
    path: Routes.privacyPolicy,
    Element: PrivacyPolicy,
    Layout: LandingLayout,
    props: {
      active: "",
    },
  },
  {
    path: Routes.termsOfUse,
    Element: TermsOfUse,
    Layout: LandingLayout,
    props: {
      active: "",
    },
  },
  {
    path: Routes.contactUs,
    Element: ContactUs,
    Layout: LandingLayout,
    props: {
      active: "",
    },
  },
  {
    path: Routes.faqs,
    Element: FAQ,
    Layout: LandingLayout,
    props: {
      active: "faq",
    },
  },
  {
    path: Routes.faqs,
    Element: FAQ,
    Layout: LandingLayout,
    props: {
      active: "faq",
    },
  },
  {
    path: Routes.talentEnablement,
    Element: TalentEnablement,
    Layout: LandingLayout,
    props: {
      active: "",
      hideFooterCta: true,
    },
  },
  {
    path: Routes.talentEnablementPreview,
    Element: TalentEnablementPreview,
  },
  // Events
  {
    path: Routes.events(":slug"),
    Element: Events,
  },
  // Auth
  {
    path: Routes.signup,
    Element: Signup,
    Layout: AuthLayout2,
  },
  {
    path: Routes.emailVerification,
    Element: EmailVerification,
  },
  {
    path: Routes.signin,
    Element: Signin,
    Layout: AuthLayout,
  },
  {
    path: Routes.forgotPassword,
    Element: ForgotPassword,
    Layout: AuthLayout,
  },
  {
    path: Routes.newPassword,
    Element: NewPassword,
    Layout: AuthLayout,
  },
  {
    path: Routes.publishAssessment,
    Element: PublishAssessment,
    Layout: EmployerDashboardLayout,
    props: {
      active: "assessment",
      noPadding: true
    },
    isProtected: true,
  },
  {
    path: Routes.manageJobs,
    Element: ManageJobs,
    Layout: EmployerDashboardLayout,
    props: {
      active: "jobs",
      noPadding: true
    },
    isProtected: true,
  },
  {
    path: Routes.reviewTalents(":id"),
    Element: ReviewTalents,
    Layout: EmployerDashboardLayout,
    props: {
      active: "jobs",
      noPadding: true
    },
    isProtected: true,
  },
  {
    path: Routes.reviewTalentsCVAnalysis(":id"),
    Element: ReviewTalentsCVAnalysis,
    Layout: EmployerDashboardLayout,
    props: {
      active: "jobs",
      noPadding: true
    },
    isProtected: true,
  },
  {
    path: Routes.analytics(":id"),
    Element: Analytics,
    Layout: EmployerDashboardLayout,
    props: {
      active: "jobs",
      noPadding: true
    },
    isProtected: true,
  },
  {
    path: Routes.report({ id: ":id", id2: ":id2" }),
    Element: AssessmentReport,
    Layout: EmployerDashboardLayout,
    props: {
      active: "jobs",
      noPadding: true
    },
    isProtected: true,
  },
  {
    path: Routes.compareCandidates({ id: ":id", id2: ":id2" }),
    Element: CompareCandidatesPage,
    Layout: EmployerDashboardLayout,
    props: {
      active: "jobs",
      noPadding: true
    },
    isProtected: true,
  },
  {
    path: Routes.publicReport({ id: ":id", role: ":role" }),
    Element: PublicReportPage,
  },
  {
    path: Routes.settings,
    Element: Settings,
    Layout: EmployerDashboardLayout,
    props: {
      active: "settings",
      noPadding: true
    },
    isProtected: true,
  },
  {
    path: Routes.creditsBilling,
    Element: CreditsBilling,
    Layout: EmployerDashboardLayout,
    props: {
      active: "pricing",
      noPadding: true
    },
    isProtected: true,
  },

  // Candidates
  {
    path: Routes.candidateAssessment(":id"),
    Element: PreAssessment,
  },
  {
    path: Routes.assessment(":id"),
    Element: Assessment,
  },
  {
    path: Routes.assessmentFeedback(":id"),
    Element: AssessmentFeedback,
  },

  {
    path: "*",
    Layout: AuthLayout,
    Element: Signin,
  },
];
